/* eslint-disable  jsx-a11y/media-has-caption */
import React from 'react';
import PropTypes from 'prop-types';
import Quagga from '@ericblade/quagga2';
import { findDesiredCamera } from '../Util.js';
import S from './QuaggaScanner.css';
export default class QuaggaScanner extends React.Component {
  static propTypes = {
    readers: PropTypes.array,
    scanning: PropTypes.bool
  };
  static defaultProps = {
    readers: ['code_128_reader'],
    scanning: true
  };
  constructor(props) {
    super(props);
    this.containerRef = /*#__PURE__*/React.createRef();
    this.canvasRef = /*#__PURE__*/React.createRef();
    this.videoRef = /*#__PURE__*/React.createRef();
    this.state = {};
  }
  async componentDidMount() {
    const {
      readers,
      scanning
    } = this.props;
    let deviceId;
    try {
      deviceId = await findDesiredCamera();
    } catch (err) {
      console.log('failed to acquire deviceId');
    }
    Quagga.init({
      locate: false,
      inputStream: {
        name: 'Live',
        type: 'LiveStream',
        target: this.containerRef.current,
        constraints: {
          width: {
            ideal: 1024
          },
          height: {
            ideal: 768
          },
          deviceId,
          facingMode: 'environment'
        },
        area: {
          top: '30%',
          right: '10%',
          left: '10%',
          bottom: '30%'
        }
      },
      decoder: {
        readers
      }
    }, err => {
      if (err) {
        this.onError(err);
        return;
      }
      Quagga.onDetected(this.onScan);
      Quagga.onProcessed(this.onProcess);
      if (scanning) {
        Quagga.start();
      }
    });
    this.videoRef.current.addEventListener('loadedmetadata', this.getVideoTransform);
    window.addEventListener('resize', this.getVideoTransform);
  }
  componentDidUpdate(prevProps) {
    const {
      scanning
    } = this.props;
    const {
      scanning: pScanning
    } = prevProps;
    if (scanning !== pScanning) {
      if (scanning) {
        Quagga.start();
      } else {
        Quagga.stop();
      }
    }
  }
  componentWillUnmount() {
    Quagga.offDetected(this.onScan);
    Quagga.offProcessed(this.onProcess);
    Quagga.stop();
    window.removeEventListener('resize', this.getVideoTransform);
    this.videoRef?.current.removeEventListener('loadedmetadata', this.getVideoTransform);
  }
  onScan = res => {
    const {
      onChange,
      eventData
    } = this.props;
    if (onChange) {
      onChange({
        value: res,
        data: eventData
      });
    }
  };
  onProcess = res => {
    const {
      onProcess,
      eventData
    } = this.props;
    if (onProcess) {
      onProcess({
        data: eventData,
        value: res
      });
    }
  };
  getVideoTransform = () => {
    const video = this.videoRef?.current;
    const clientHeight = video?.clientHeight;
    const clientWidth = video?.clientWidth;
    const videoHeight = video?.videoHeight;
    const videoWidth = video?.videoWidth;
    if (clientHeight && clientWidth && videoHeight && videoWidth) {
      const widthDiff = videoWidth - clientWidth;
      const heightDiff = videoHeight - clientHeight;
      let nHeight;
      let nWidth;
      if (heightDiff > widthDiff) {
        nHeight = clientHeight;
        nWidth = videoWidth * (clientHeight / videoHeight);
      } else {
        nHeight = videoHeight * (clientWidth / videoWidth);
        nWidth = clientWidth;
      }
      this.setState({
        scanHeight: nHeight,
        scanWidth: nWidth
      });
    }
  };
  render() {
    const {
      id
    } = this.props;
    const {
      scanWidth,
      scanHeight
    } = this.state;
    return /*#__PURE__*/React.createElement("div", {
      id: id,
      className: S.container,
      ref: this.containerRef
    }, /*#__PURE__*/React.createElement("video", {
      ref: this.videoRef
    }), /*#__PURE__*/React.createElement("div", {
      style: {
        width: scanWidth,
        height: scanHeight,
        position: 'absolute'
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: S.scanBox
    }, /*#__PURE__*/React.createElement("div", {
      className: S.scanLine
    }))));
  }
}